import React, { useEffect, useMemo } from "react";
import { gallerySchema } from "../../schema/schema";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { useGymFilter } from "../../hooks/useGymFilter";
import Select from "react-select";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import { Form } from "react-bootstrap";
import {
  commonPostPutFormData,
  fetchApiData,
} from "../../redux/reducers/commonApiSlice";
import { add_gallery } from "../../data/ApiEndpoints";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import "./gallery.css";
import { isVideo, isVideoSelected } from "./galleryUtils";

const GalleryForm = ({ closeModal, userInfoData, reloadGalleryData }) => {
  const dispatch = useDispatch();
  const { gymData } = useGymFilter();

  const { data: galleryCategoryData } = useSelector((state) => state?.common);

  console.log("galleryCategoryData", galleryCategoryData);

  const getGalleryCategories = () => {
    dispatch(
      fetchApiData({
        method: "GET",
        endpoint: "/gallerycategory",
        token: userInfoData?.token,
        payload: {
          filters: "",
        },
      })
    );
  };

  useEffect(() => {
    getGalleryCategories();
  }, []);

  const galleryCategoryOpitons = useMemo(() => {
    if (galleryCategoryData) {
      return galleryCategoryData?.data?.map((item) => ({
        value: item?.uid,
        label: item?.name,
      }));
    } else {
      return [];
    }
  }, [galleryCategoryData]);

  const formik = useFormik({
    initialValues: {
      gym_id: "",
      category_id: "",
      status: "active",
      image: "",
    },
    validationSchema: gallerySchema,
    onSubmit: async (values) => {
      console.log("values", values);

      const formData = new FormData();
      formData.append("gym_id", values.gym_id);
      formData.append("uid", values.gym_id);
      formData.append("category_id", values.category_id);
      formData.append("status", values.status);

      values.image.forEach((file) => {
        formData.append("image", file);
      });

      const result = await dispatch(
        commonPostPutFormData({
          method: "POST",
          endpoint: add_gallery,
          token: userInfoData?.token,
          requestBody: formData,
        })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        reloadGalleryData();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    },
  });

  const onChangeInput = (e) => {
    const { checked } = e.target;
    if (checked === true) {
      formik.setFieldValue("status", "active");
    } else {
      formik.setFieldValue("status", "inactive");
    }
  };

  const removeImage = (index) => {
    formik.setFieldValue(
      "image",
      formik.values.image.filter((_, i) => i !== index)
    );
  };

  console.log("formik.values.image", formik.values.image);

  return (
    <div className="createNewCTOModalContainer mod-width-70p">
      <CommonHeadingNBtns
        title="Add Gallery"
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        btnTxt="Save"
        onClose={closeModal}
      />

      <form className="formContainer" onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid threeGridSystem">
          <div className="formInputBox">
            <label>
              Select Gym <span className="text-danger">*</span>
            </label>

            <div className={`commonWrapper dropdownCommonWrapper `}>
              <Select
                options={gymData?.length > 0 ? gymData : []}
                value={gymData.find(
                  (gym) => gym?.value === formik?.values?.gym_id
                )}
                onChange={(opt) => formik?.setFieldValue("gym_id", opt?.value)}
                id="gym_id"
                name="gym_id"
                className="select__Input"
                placeholder="Select Gym"
                isSearchable={true}
              />
            </div>
            {formik.touched.gym_id && formik.errors.gym_id ? (
              <div className="error-message">{formik.errors.gym_id}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label>
              Category <span className="text-danger">*</span>
            </label>
            <div className={`commonWrapper dropdownCommonWrapper `}>
              <Select
                options={
                  galleryCategoryOpitons?.length > 0
                    ? galleryCategoryOpitons
                    : []
                }
                value={galleryCategoryOpitons.find(
                  (option) => option.value === formik?.values?.category_id
                )}
                onChange={(opt) =>
                  formik?.setFieldValue("category_id", opt?.value)
                }
                id="category_id"
                name="category_id"
                className="select__Input"
                placeholder="Select Category"
                isSearchable={true}
              />
            </div>
            {formik.touched.category_id && formik.errors.category_id ? (
              <div className="error-message">{formik.errors.category_id}</div>
            ) : null}
          </div>

          <div className="formInputsGrid switchInputs">
            <div className="formInputBox formInputSwitchBox">
              <label>
                Status <span className="text-danger">*</span>
              </label>
              <div className={`commonWrapper commonSwitchWrapper no-border`}>
                <Form.Check
                  type="switch"
                  name="isActive"
                  label={formik?.values?.status}
                  checked={formik.values.status === "active"}
                  onChange={onChangeInput}
                />
              </div>
            </div>
          </div>

          <div>
            <div className="formInputBox">
              <label>
                Add Single Or Multiple Images{" "}
                <span className="text-danger">*</span>
              </label>
              <div>
                <input
                  type="file"
                  name="image"
                  accept="image/*,video/*"
                  onChange={(event) => {
                    const files = Array.from(event.currentTarget.files);

                    if (files.length > 5) {
                      toast.error("You can upload a maximum of 5 images");
                      return;
                    }

                    formik.setFieldValue("image", files);
                  }}
                  multiple
                />
                {formik.touched.image && formik.errors.image ? (
                  <div className="error-message">{formik.errors.image}</div>
                ) : null}
              </div>
            </div>

            {formik?.values?.image?.length > 0 && (
              <div className="formInputBox">
                <label>
                  Preview <span className="text-danger">*</span>
                </label>
                <div className="selectedImages_Wrapper">
                  {formik?.values?.image?.map((file, index) => (
                    <div className="selectedImages">
                      {isVideoSelected(file) ? (
                        <video
                          controls
                          src={URL.createObjectURL(file)}
                          style={{
                            objectFit: "contain",
                            width: "200px",
                            height: "100px",
                          }}
                        />
                      ) : (
                        <img
                          key={index}
                          src={URL.createObjectURL(file)}
                          alt={`Preview ${index + 1}`}
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                          }}
                        />
                      )}
                      <button
                        type="button"
                        className="remove-image-btn"
                        onClick={() => removeImage(index)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-x"
                          viewBox="0 0 16 16"
                        >
                          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                        </svg>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default GalleryForm;
